import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AxiosResponse } from 'axios';
import moment from 'moment';
import { Badge, Button, Card, CardBody, CardHeader, Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Input, InputGroup, InputGroupAddon, InputGroupText, Table } from 'reactstrap';

import useTeacherProfile from '../../Hooks/useTeacherProfile';
import { getStudentsList } from '../../Services/Student/StudentService';

import CustomTable from '../../components/Tables/CustomTable';
import Image from '../../components/utils/Image';
import { PATHS } from '../../routes';
import { TypeTeacherSchool } from '../../Reducers/types';
import { typeGradeSection, TypeStudentList } from '../../types';
import DotsSpinner from '../../components/Loader/DotsSpinner/DotsSpinner';
import { toast } from 'react-toastify';
import Header from '../../components/Headers/Header';
import { Search } from 'react-bootstrap-icons';

export default function ShowStudents() {

    const history = useHistory();
    const teacherProfile: TypeTeacherSchool = useTeacherProfile(); // stores teacher profile information
    const params = new URLSearchParams(); // to read the query parameters from location URL

    // --- DROPDOWN GRADE ---
    const [gradeDropdownOpen, setGradeDropdownOpen] = useState(false);
    const gradeDropdownToggle = () => setGradeDropdownOpen(prevState => !prevState);

    // --- GRADE-SECTION-SUBJECT ---
    const [gradeSectionInfo, setGradeSectionInfo] = useState<typeGradeSection[]>([]); // stores grade-section-subject information
    const [selectedGrade, setSelectedGrade] = useState<typeGradeSection>(); // stores selected grade

    const [studentList, setStudentList] = useState<TypeStudentList[]>([]); // stores fetched student list
    const [searchByName, setSearchByName] = useState<string>(''); // stores query for searching by student name

    const [isLoading, setIsLoading] = useState<boolean>(false); // if data is getting loaded - true

    useEffect(() => {
        // const url_string = new URL(window.location.href.toLowerCase()).searchParams.get("grade");
        // const url = new URL(url_string);
        // const searchGrade: any = url.searchParams.get("grade");
        // if (url_string) { studentListByParam(url_string) }
        filterGrades();;
    }, [history.location]);
    useMemo(() => {
        // getStudentList();
        setSelectedGrade(gradeSectionInfo[0]);
    }, [gradeSectionInfo]);

    // filters grades from teacher profile
    const filterGrades = () => {
        if (Number(teacherProfile?.gradelist.length) === 0) { toast.error("Can not get grades. Please log in again!") }
        // filters grade-section list based on current session
        setGradeSectionInfo(
            teacherProfile?.gradelist?.filter(({ grade_section_id, subject }) => {
                if (moment(new Date()).format('YYYY-MM-DD') >= moment(grade_section_id?.session?.session_start).format('YYYY-MM-DD')
                    &&
                    moment(new Date()).format('YYYY-MM-DD') <= moment(grade_section_id?.session?.session_end).format('YYYY-MM-DD')) {
                    return { grade_section_id, subject };
                }
            })
        );
    };

    // fetches student list based on grade-section selection
    const getStudentList = () => {
        setIsLoading(true);

        getStudentsList(selectedGrade?.grade_section_id?.id).then(
            (response: AxiosResponse) => {
                console.log("Response for student list: ", response?.data?.data);
                setStudentList(response?.data?.data);
                setIsLoading(false);
                // params.append("grade", selectedGrade?.grade_section_id?.id); // append the parameter to the url
                // history.push({ search: params.toString() }); // pushing new history
            }, (error) => {
                console.log("Error caught: ", error?.response);
                setIsLoading(false);
                toast.error("Could not fetch student list!");
            }
        ).catch(error => { console.log("Catched error ---> ", error); setIsLoading(false) });
    };

    // searches student by
    const searchStudentByName = (e) => {
        e.preventDefault();
        if (e.key === 'Enter') {
            // setSearchByName(e.target.value);
            console.log("Search called!!!", e.target.value);
        }
    };

    return (
        <React.Fragment>

            <Header />

            <Container className="mt--7" fluid>
                <Card className="mb-4 mb-xl-0">
                    <CardHeader className="border-0">
                        <h3 className="mb-0 text-muted"><i className="fas fa-users mr-1"></i> Student List</h3>
                        {/* FOR FILTERS */}
                        <div className="d-flex align-items-center p-2 mt-3 rounded filter-div-bg">
                            {/* FOR GRADES */}
                            <Dropdown size="sm" isOpen={gradeDropdownOpen} direction="down" toggle={gradeDropdownToggle}>
                                <DropdownToggle caret>
                                    {selectedGrade ? <span>Selected Grade: <span className="text-primary">{selectedGrade?.grade_section_id?.grade?.name} - {selectedGrade?.grade_section_id?.section?.type}</span></span> : 'Select Grade'}
                                </DropdownToggle>
                                <DropdownMenu style={{ maxHeight: 300, overflow: 'auto' }}>
                                    {
                                        gradeSectionInfo?.length !== 0 ? gradeSectionInfo?.map((each, index) => (
                                            <DropdownItem key={index} onClick={() => setSelectedGrade(each)}>
                                                <span className="d-flex justify-content-between align-items-center">
                                                    {each?.grade_section_id?.grade?.name} - {each?.grade_section_id?.section?.type}
                                                    {selectedGrade?.grade_section_id?.grade?.id === each?.grade_section_id?.grade?.id && <i className="fas fa-check-circle text-primary"></i>}
                                                </span>
                                            </DropdownItem>
                                        )) : <span className="small text-muted text-center">No Grades Available</span>
                                    }
                                </DropdownMenu>
                            </Dropdown>
                            {/* <Button color="secondary" size="sm" disabled={!selectedGrade} onClick={() => setSelectedGrade(null)}>Show All</Button> */}
                            {/* <Input type="text" placeholder="Search name..." className="form-control-sm" value={searchByName} onChange={(e) => setSearchByName(e.target.value)} onKeyDown={(e) => searchStudentByName(e)} /> */}
                            <InputGroup size="sm">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText><Search /></InputGroupText>
                                </InputGroupAddon>
                                <Input placeholder="Search student by srn number" value={searchByName} onChange={(e) => setSearchByName(e.target.value)} onKeyUp={(e) => searchStudentByName(e)} />
                                {searchByName ? <InputGroupAddon addonType="append" className="pointer" onClick={() => { setSearchByName('') }}>
                                    <InputGroupText><i className="fas fa-times"></i></InputGroupText>
                                </InputGroupAddon> : <></>}
                            </InputGroup>
                        </div>
                    </CardHeader>

                    <CardBody className="overflow-auto pt-0" style={{ minHeight: 300 }}>

                        <div>
                            <CustomTable
                                url={(searchByName.length < 3) ? `items/student_profile_grade_section?filter[grade_section_id]=${selectedGrade?.grade_section_id?.id}&fields=id,student_profile_id.user.*.*,student_profile_id.contact_no&limit=10&meta=filter_count`
                                    :
                                    `items/student_profile_grade_section?filter[grade_section_id]=${selectedGrade?.grade_section_id?.id}&filter[student_profile_id.user.srn_no][contains]=${searchByName}&fields=id,student_profile_id.user.*.*,student_profile_id.contact_no&limit=10&meta=filter_count`
                                } // (selectedGrade?.grade_section_id?.id) ? : `items/student_profile_grade_section?fields=id,student_profile_id.user.*.*,student_profile_id.contact_no&limit=5&meta=filter_count` &filter[student_profile_id.user.first_name][contains]=${searchByName}
                                column={[
                                    // { key: "id", label: "ID" },
                                ]}
                                tableTitle={'All Students'}
                                searchBox={false}
                                itemsLimit={10}
                                customFunction={() => { }}
                                customColumns={[
                                    {
                                        heading: "Student",
                                        renderer: (item: any) => (
                                            <div className="d-flex align-items-center pointer text-primary" onClick={() => history.push(PATHS.studentProfile + '/' + item?.student_profile_id?.user?.id)}>
                                                <Image source={item?.student_profile_id?.user?.avatar?.data?.thumbnails[1]?.url} size={30} classes={"rounded-circle"} />
                                                <span className="pl-1">{item?.student_profile_id?.user?.first_name} {item?.student_profile_id?.user?.last_name}</span>
                                            </div>
                                        ),
                                    },
                                    {
                                        heading: "SRN No",
                                        renderer: (item: any) => (
                                            <React.Fragment>{item?.student_profile_id?.user?.srn_no || 'Not Available'}</React.Fragment>
                                        ),
                                    },
                                    {
                                        heading: 'Status',
                                        renderer: (item: any) => (
                                            <Badge color={item?.student_profile_id?.user?.status === 'active' ? 'success' : 'danger'}>{item?.student_profile_id?.user?.status}</Badge>
                                        )
                                    }
                                ]} />
                        </div>

                    </CardBody>
                </Card>

            </Container>


        </React.Fragment>
    )
}
